<template>
  <center>
    <div style="height: 60px"></div>

    <v-row justify="center" no-gutters>
        <v-card
          class="pa-0 ma-3"
          width="20%"
          min-width="270"
          rounded="lg"
          ripple
          :style="s.estiloTarjeta"
          elevation="5"
          v-for="s in sensores"
          :key="s.idSensor"
          :to="{ name: 'grafica', query: { idSensor: s.idSensor } }"
        >
          <v-btn
            ref="botonPlus"
            class="botonPropiedadesSensor"
            dark
            icon
            small
            :color="s.colorBoton"
            :to="{ name: 'modificarSensor', params: { id: s.idSensor } }"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>

          <!-- Titulo de la tarjeta -->
          <v-card-title style="font-weight: 300">
            {{ s.descripcion }}
          </v-card-title>

          <!-- Cuerpo de la tarjeta -->
          <v-card-text class="mt-n4">
            <div style="font-weight: 100" class="subtitle-3 text-left">
              {{ s.localizacion }}
            </div>
            <!-- TEMPERATURA  -->
            <v-col class="headline mt-n2">
              <span v-if="!s.alertaTemperatura">
                <v-icon>mdi-thermometer</v-icon>
              </span>
              <span v-else>
                <v-icon color="red" class="parpadeante">mdi-thermometer-alert</v-icon>
              </span>
              Temp.:
              <span style="color: yellow">{{ s.temperatura }}&deg;C</span>
            </v-col>
            <!-- HUMEDAD -->
            <v-col class="body-1 mt-n4 mb-n1">
              <span v-if="!s.alertaHumedad">
                <v-icon>mdi-water-percent</v-icon>
              </span>
              <span v-else>
                <v-icon color="red" class="parpadeante">mdi-water-percent-alert</v-icon>
              </span>
              Humedad:
              <span style="color: yellow">{{ s.humedad }}% HR</span>
            </v-col>
            <!-- PUERTA ABIERTA -->
            <v-col v-if="s.tipoSensor == 2 && s.puertaAbierta" class="body-1 mt-n4 mb-n1">
              <span v-if="!s.puertaAbierta">
                <v-icon>mdi-door-closed</v-icon>
              </span>
              <span v-else>
                <v-icon color="red" class="parpadeante">mdi-door-open</v-icon>
              </span>
              Puerta:
              <span style="color: yellow">Abierta</span>
            </v-col>
            <!-- MENSAJE DE ALERTA (NARANJA) -->
            <v-alert
              v-show="s.alerta"
              dense
              border="left"
              color="#E53935"
              style="font-weigth: 100; font-size: 8pt"
              class="pb-1 mb-0"
            >
              <span v-html="s.alerta"></span>
            </v-alert>
          </v-card-text>
        </v-card>
    </v-row>

    <div class="mt-6" v-if="respuestaPeticionSensores && (sensores.length == 0)">
      <v-alert
        width="87vw"
        border="left"
        light
        colored-border
        type="info"
        elevation="4"
      >
        <strong>No se han registrado sensores</strong><br><br>
        <span class="body-2">Para añadir un sensor, pulse sobre el botón (+) situado en la parte inferior derecha de la pantalla</span>
      </v-alert>
    </div>



    <!--v-btn-toggle v-model="toggle_multiple" class="btn-toggle transparent_tools"  multiple>
      <v-btn @click="optionClick(0)">
        <v-icon >mdi-thermometer</v-icon>
      </v-btn>
      <v-btn @click="optionClick(1)">
        <v-icon>mdi-water-percent</v-icon>
      </v-btn>
      <v-btn @click="optionClick(2)">
        <v-icon>mdi-door-open</v-icon>
      </v-btn>
      <v-btn @click="optionClick(3)">
        <v-icon>mdi-connection</v-icon>
      </v-btn>
    </v-btn-toggle-->



    <v-btn
      id="boton"
      class="botonAnadirSensor"
      elevation="5"
      fab
      dark
      color="blue-grey darken-1"
      :to="{ name: 'anadirSensor' }"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </center>
</template>

<script>
import api from "@/api";
import { DateTime } from "luxon";
import tinycolor from "tinycolor2";

export default {
  name: "Inicio",

  data: () => ({
    respuestaPeticionSensores: false,
    sensores: [],
    manejadorTimeout: null,
   /* toggle_multiple: [0,1,2,3],
    btn_temperatura: true,
    btn_humedad: true,
    btn_puertaabierta: true,
    btn_conexion: true*/
  }),

  methods: {
    /*optionClick: function (id) {
      switch (id) {
        case 0: this.btn_temperatura = !this.btn_temperatura;  break;
        case 1: this.btn_humedad = !this.btn_humedad; break;
        case 2: this.btn_puertaabierta = !this.btn_puertaabierta; break;
        case 3: this.btn_conexion = !this.btn_conexion; break;
      }
    },*/
    actualizarDatos() {
      try {
        if (this.$global.appActiva) {
          api
            .estadoSensores()
            .then ((respuesta) => {
              this.$global.numeroAlertasPendientes = respuesta.data.numeroalertaspendientes;
              this.$global.numeroAlertasPendientesDesde = respuesta.data.numeroalertaspendientesdesde;
              this.sensores = respuesta.data.sensores;
              
              this.sensores.forEach(s => {

                s.colorBoton = tinycolor (s.color).lighten (20).toHexString();
                s.estiloTarjeta = `background: ${s.color};`;
                s.alertaTemperatura = s.alarmaTemperatura && ((s.temperatura < s.alarmaTemperaturaPorDebajoDe) || (s.temperatura > s.alarmaTemperaturaPorEncimaDe));
                s.alertaHumedad = s.alarmaHumedad && ((s.humedad < s.alarmaHumedadPorDebajoDe) || (s.humedad > s.alarmaHumedadPorEncimaDe));
                s.alertaPuerta = (s.tipoSensor == 2) && s.alarmaPuertaAbierta && s.puertaAbierta;

                if (s.alertaTemperatura || s.alertaHumedad || s.alertaPuerta)
                  s.estiloTarjeta = s.estiloTarjeta + "border: #FF3030 4px solid;"

                if (!s.ultimaActualizacion) {
                  s.temperatura = "---";
                  s.humedad = "---";
                  s.alerta = "Todavía no se han recibido datos";
                } else if (DateTime.fromISO (s.ultimaActualizacion).diffNow ().as('seconds') < -120) {
                  let minutos = Math.abs (DateTime.fromISO (s.ultimaActualizacion).diffNow ().as('minutes'));
                  if (minutos < 60)
                    s.alerta = "Última actualización:<br>Hace "+Math.trunc(minutos)+" minutos";
                  else if (minutos < 1440)
                    s.alerta = "Última actualización:<br>Hace "+Math.trunc(minutos / 60)+" horas";
                  else
                    s.alerta = "Última actualización:<br>"+DateTime.fromISO (s.ultimaActualizacion).toLocaleString (DateTime.DATETIME_MED_WITH_WEEKDAY);
                }
              });
              this.respuestaPeticionSensores = true;
            })
            .finally(() => {
              this.$global.cargando = false;
            });
        }
      } finally {
        if (this.$store.getters.usuarioLogado)
          this.manejadorTimeout = setTimeout(this.actualizarDatos, 5000);
      }
    },
  },

  mounted() {
    this.$global.cargando = true;
    this.actualizarDatos();
    
  },
  beforeDestroy() {
    clearTimeout(this.manejadorTimeout);
  },
};
</script>

<style>
.botonAnadirSensor {
  position: fixed;
  right: 25px;
  bottom: 22px;
}
.botonPropiedadesSensor {
  position: absolute;
  right: 8px;
  top: 16px;
}
.parpadeante {
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  29% { opacity: 1; }
  30% { opacity: 0; }
  69% { opacity: 0; }
  70% { opacity: 1; }
}
.btn-toggle2 {
  flex-direction: column;
  position: fixed;
  left: 5px;
  top: 70px;
}
.transparent_tool {
   background-color: white!important;
   opacity: 0.85;
   border-color: transparent!important;
 }
</style>